import {toPaymentContract} from './mappers/toPaymentContract'
import type {CreatePaymentContractService} from './types'

export const createPaymentContractService: CreatePaymentContractService = function createPaymentContractService(
  cargoRepository,
  dcaaRepository,
  cargoCorpRepository,
) {
  const {fetchPaymentMethodsList} = cargoRepository
  const {fetchPaymentMethodActualState} = dcaaRepository
  const {fetchCreatePdfInvoice} = cargoCorpRepository

  return {
    async fetchPaymentContractDetails() {
      const [paymentMethods, actualState] = await Promise.all([
        fetchPaymentMethodsList({mode: 'employee'}),
        fetchPaymentMethodActualState(),
      ])

      return toPaymentContract(paymentMethods, actualState)
    },
    async getPdfInvoiceLink(penaltyAmount) {
      return fetchCreatePdfInvoice({amount: penaltyAmount, target: 'penalty'}).then(response => response.mds_link)
    },
  }
}
